import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
import { isRichContent, toPlainText } from '../../../services/rich-content';
function isEcomSubscriptionCheckbox(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.ECOM_SUBSCRIPTION && isRichContent(label) && (typeof value === 'boolean' || value === null);
}
function _formatEcomSubscriptionCheckbox(_ref) {
  let {
    field,
    value
  } = _ref;
  if (typeof value !== 'boolean' || value === false) {
    return;
  }
  const label = toPlainText(field.view.label);
  return {
    label,
    value
  };
}
export function formatEcomSubscriptionCheckbox(submission) {
  if (isEcomSubscriptionCheckbox(submission)) {
    return _formatEcomSubscriptionCheckbox(submission);
  }
  return undefined;
}
//# sourceMappingURL=ecom-subscription-checkbox-preview.js.map